import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./DiscoveryManagement.scss";
import "../../styles/global.scss";
import "../../styles/pagelayout.scss";

// React Bootstrap components
import { Container, Row, Col, Tabs, Tab } from "react-bootstrap";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Auth from "@aws-amplify/auth";

// Components
import TableMUI from "../components/TableMUI/TableMUI";
import { PartnersTableColumns } from "../components/TableMUI/TableColumns";
import Sidebar from "../components/sidebar/Sidebar";

import DetailsDisplayModal from "../components/modalForms/DiscoveryManagement/DetailsDisplayModal";
import PartnerChat from "./PartnerChat";
import BrandApprovalPartner from "../components/modalForms/DiscoveryManagement/BrandApprovePartner";
import {
  getAcceptedPartners,
  getBrandRequestByID,
  GetBrandRequests,
  getInterestedPartners,
  GetInterestForBrand,
  getRecommendedPartners,
  GetSuitablePartners,
} from "../../API/endpoints/Discovery";
import { GetCountries } from "../../API/endpoints/Common";
import { countriesDTO } from "../dtos/brand.dtos";
import Cookies from "js-cookie";
import Navbar from "../components/header/NavBar";
import { GetUserProfile } from "../../API/endpoints/User";
import {
  GetPermissionsByRoleAndModuleID,
  GetRoleById,
} from "../../API/endpoints/RolesAndPermissions/Roles";
import { GetPublicFiles } from "../../API/endpoints/fileupload/Files";
import { Avatar, Chip, Divider } from "@mui/material";
import ChipWithIcon from "../components/Chip/ChipWithIcon";
import DocumentItem from "../components/documentItem/DocumentItem";
import ViewRecommendedServices from "../components/modalForms/DiscoveryManagement/ViewRecommendedServices";
import { abbreviateNumber } from "../../common/helpers";

function RecommendPartner() {
  const navigate = useNavigate();

  const [userType, setUserType] = useState<string>("");
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState<boolean>(false);
  const [flag, setFlag] = useState(false);
  const [showApprovePartnerModal, setShowApprovePartnerModal] = useState(false);
  const [showViewConfirmedModal, setViewConfirmedModal] = useState(false);
  const [showChatModal, setShowChatModal] = useState(false);
  const [dataCount, setDataCount] = useState(0);
  const [data, setData] = useState<{ rows: any[] }>();
  const [partnerListPage, setPartnerListPage] = useState(0);
  const [countries, setCountries] = useState<countriesDTO[]>([]);
  const [searchParam, setSearchParam] = useState<string>("");
  const [selectedRequest, setSelectedRequest] = useState();
  const [selectedPartnerID, setSelectedPartnerID] = useState<string>("");
  const [defaultTab, setDefaultTab] = useState<any>("");
  const [selectedRequestID, setSelectedRequestID] = useState<
    string | undefined
  >("");
  const [partnerDataCount, setPartnerDataCount] = useState(0);
  const [newdata, setNewdata] = useState<any>([]);
  const [newDataCount, setNewDataCount] = useState<number | undefined>(0);
  const [userID, setUserID] = useState<string | undefined>("");
  const [userProfile, setUserProfile] = useState<any>({});
  const [roleID, setRoleID] = useState<string | undefined>("");
  const [permissions, setPermissions] = useState<any>([]);
  const [publicFiles, setPublicFiles] = useState<any>([]);
  const [requestDetails, setRequestDetails] = useState<any>({});
  const [brandDetails, setBrandDetails] = useState<any>({});
  const [marketPlaceDetails, setMarketPlaceDetails] = useState<any[]>([]);
  const [socialMedialDetails, setSocialMediaDetails] = useState<any[]>([]);
  const [brandDocumentsList, setBrandDocumentsList] = useState<any[]>([]);

  const [suitableList, setSuitableList] = useState<any>([]);
  const [interestedList, setInterestedList] = useState<any>([]);
  const [recommendedList, setRecommendedList] = useState<any>([]);
  const [acceptedList, setAcceptedList] = useState<any>([]);

  const [suitableCount, setSuitableCount] = useState<string>("");
  const [interestedCount, setInterestedCount] = useState<string>("");
  const [recommendedCount, setRecommendedCount] = useState<string>("");
  const [acceptedCount, setAcceptedCount] = useState<string>("");
  const [chatData, setChatData] = useState<any>([]);
  const [list, setList] = useState<any>([]);
  const [dataSource, setDataSource] = useState<any>([]);

  const handleCloseDetailsModal = () => setIsDetailsModalOpen(false);
  const handleCloseApprovePartner = () => setShowApprovePartnerModal(false);
  const handCloseViewConfirmedModal = () => setViewConfirmedModal(false);
  const params = useParams();
  const handleChatModal = () => {
    setShowChatModal(false);
  };

  const [activeTab, setActiveTab] = useState("interested");

  useEffect(() => {
    setActiveTab(userType !== "organization" ? "suitable" : "interested");
  }, [userType]);

  useEffect(() => {
    setUserID(Cookies.get("userID"));
    if (userID) {
      (async () => {
        const response = await GetUserProfile(userID);
        if (response?.data) {
          setUserProfile(response?.data);
        }
      })();
    }
  }, [userID]);

  useEffect(() => {
    setUserID(Cookies.get("userID"));
  }, []);

  useEffect(() => {
    if (userID) {
      (async () => {
        const response = await GetUserProfile(userID);
        if (response?.data) {
          setRoleID(response.data?.user_roles[0]?.roles.id);
          setUserProfile(response?.data);
        }
      })();
    }
  }, [userID]);


  useEffect(() => {
    getBrandRequestByID(params?.id, 18).then((res) => {
      setRequestDetails(res.data);
      setBrandDetails(res.brand);

      setMarketPlaceDetails(res?.brand?.market_place || []);
      setSocialMediaDetails(res?.brand?.social_media || []);
      setBrandDocumentsList(res?.brandDocuments ? res.brandDocuments : []);
    });


  }, [params, flag]);

  useEffect(() => {
    if (userType !== "organization") {
      getSuitablePartnersList(params?.id);
    }

    getInterestedPartnersList(params?.id);
    getRecommendedPartnersList(params?.id);
    getAcceptedPartnersList(params?.id);
  }, [params, flag, showChatModal])

  useEffect(() => {
    if (partnerListPage > 1) {
      switch (activeTab) {
        case "suitable":
          if (userType !== "organization") {
            setInterestedList([]);
            setRecommendedList([]);
            setAcceptedList([]);
            GetSuitablePartners(params?.id, partnerListPage)
              .then((res) => {
                setSuitableList((prevData: any) => [
                  ...prevData,
                  ...res.data.rows,
                ]);
              })
              .catch((err) => console.log(err));
          }

          break;
        case "interested":
          setSuitableList([]);
          setRecommendedList([]);
          setAcceptedList([]);
          getInterestedPartners(params?.id, partnerListPage)
            .then((res) => {
              setInterestedList((prevData: any) => [
                ...prevData,
                ...res.data.rows,
              ]);
            })
            .catch((err) => console.log(err));
          break;
        case "recommended":
          setSuitableList([]);
          setInterestedList([]);
          setAcceptedList([]);
          getRecommendedPartners(params?.id, partnerListPage)
            .then((res) => {
              setRecommendedList((prevData: any) => [
                ...prevData,
                ...res.data.rows,
              ]);
            })
            .catch((err) => console.log(err));
          break;
        case "accepted":
          setSuitableList([]);
          setInterestedList([]);
          setRecommendedList([]);
          getAcceptedPartners(params?.id, partnerListPage)
            .then((res) => {
              setAcceptedList((prevData: any) => [
                ...prevData,
                ...res.data.rows,
              ]);
            })
            .catch((err) => console.log(err));
          break;

        default:
          break;
      }
    }
  }, [partnerListPage, activeTab, showChatModal]);

  useEffect(() => {
    switch (activeTab) {
      case "suitable":
        setPartnerDataCount(Number(suitableCount));
        setList([...suitableList]);
        break;
      case "interested":
        setPartnerDataCount(Number(interestedCount));
        setList([...interestedList]);
        break;
      case "recommended":
        setPartnerDataCount(Number(recommendedCount));
        setList([...recommendedList]);
        break;
      case "accepted":
        setPartnerDataCount(Number(acceptedCount));
        setList([...acceptedList]);
        break;

      default:
        break;
    }
  }, [activeTab, interestedList, acceptedList, recommendedList, suitableList]);

  useEffect(() => {
    let rows: {
      id: any;
      partner_id: any;
      company_name: any;
      services: any;
      country: any;
      partner_services?: any[] | [];
      servicerequestIds?: any[] | [];
    }[] = [];
    if (
      list &&
      permissions[0]?.sub_modules[1]?.permissions_actions[1]?.permission[0]
        ?.permission === true
    ) {
      rows = list?.map((dataItem: any, index: number) => {
        let serviceList: any = [];
        if (dataItem?.market && dataItem?.market?.length > 0) {
          const sCapabilities = dataItem?.market[0]?.service_capabilities;

          if (sCapabilities.includes("regulatory_compliance"))
            serviceList.push("Regulatory Compliance");
          if (sCapabilities.includes("importation_clearance"))
            serviceList.push("Importation and Clearance");
          if (sCapabilities.includes("warehousing_storage"))
            serviceList.push("Warehousing And Storage");
          if (sCapabilities.includes("ecom_setup_mgmt"))
            serviceList.push("Ecommerce Setup & Management");
          if (sCapabilities.includes("retail_distribution"))
            serviceList.push("Retail Distribution");
          if (sCapabilities.includes("order_fulfilment"))
            serviceList.push("Order Fulfillment");
          if (sCapabilities.includes("marketing"))
            serviceList.push("Marketing");
        } else {
          if (dataItem?.regulatory_compliance)
            serviceList.push("Regulatory Compliance");
          if (dataItem?.importation_clearance)
            serviceList.push("Importation and Clearance");
          if (dataItem?.warehousing_storage)
            serviceList.push("Warehousing And Storage");
          if (dataItem?.ecom_setup_mgmt)
            serviceList.push("Ecommerce Setup & Management");
          if (dataItem?.retail_distribution)
            serviceList.push("Retail Distribution");
          if (dataItem?.order_fulfilment) serviceList.push("Order Fulfillment");
          if (dataItem?.marketing) serviceList.push("Marketing");
        }

        return {
          id: dataItem?.id ? dataItem?.id : index,
          brandName: requestDetails?.brand?.brand_name,
          market_id: requestDetails?.country?.id,
          partner_id: dataItem?.partnerv2_id
            ? dataItem.partnerv2_id
            : dataItem?.id,
          documents: dataItem?.partner_documentsv2
            ? dataItem.partner_documentsv2
            : dataItem?.partnerv2?.partner_documentsv2
              ? dataItem.partnerv2.partner_documentsv2
              : [],
          discovery_brand_id: dataItem?.discovery_brands_id,
          messageStatus: (dataItem?.partnerv2?.Unread_messages && dataItem?.partnerv2?.Unread_messages?.length > 0) ? dataItem?.partnerv2?.Unread_messages[0]?.status : (dataItem?.Unread_messages && dataItem?.Unread_messages?.length > 0) ? dataItem?.Unread_messages[0]?.status :"READ",
          company_name: dataItem?.name
            ? dataItem?.name
            : dataItem?.partnerv2?.name,
          services: serviceList,
          country: dataItem?.region?.name,
          market: requestDetails?.country?.name,
          servicerequestIds: dataItem?.partner_services?.map(
            (service: { service_id: any }) => {
              return service.service_id;
            }
          ),
          partner_services: dataItem?.partner_services
            ? dataItem.partner_services
            : [],
          serviceRequests: dataItem.partner_services
            ? dataItem.partner_services?.map(
              (service: { service_id: number }) => {
                if (service.service_id === 1) return "Requlatory Compliance";
                if (service.service_id === 2)
                  return "Importation and Clearance";
                if (service.service_id === 3)
                  return "Warehousing And Storage";
                if (service.service_id === 4)
                  return "Ecommerce Setup & Management";
                if (service.service_id === 5) return "Retail Distribution";
                if (service.service_id === 6) return "Order Fulfillment";
                if (service.service_id === 7) return "Marketing";
                return "";
              }
            )
            : [],
          status: dataItem?.status
            ? dataItem?.status
            : dataItem?.partner_recommendation_status
              ? dataItem?.partner_recommendation_status
              : activeTab == "suitable"
                ? ""
                : "New",
          recommendation_status: dataItem?.partner_recommendation_status,
          isRecommended:
            dataItem.status === "Completed" &&
              dataItem?.partner_recommendation_status
              ? dataItem?.partner_recommendation_status === "Recommended"
              : false,
          tab: activeTab,
          unread_messages:
            activeTab == "suitable"
              ? dataItem?.Unread_messages.length != 0
                ? false
                : true
              : true,
          brand_id: params.id,
        };
      });
    }

    setDataSource([...rows]);
  }, [list, permissions, requestDetails, showChatModal]);

  useEffect(() => {
    if (roleID) {
      (async () => {
        const roleDetails = await GetRoleById(roleID.toString());
        setUserType(roleDetails?.data?.type);
        if (roleDetails?.data?.type === "organization") {
          const response = await GetPermissionsByRoleAndModuleID(
            roleID.toString(),
            "10"
          );
          setPermissions(response?.data);
        } else if (roleDetails?.data?.type === "administrative") {
          const response = await GetPermissionsByRoleAndModuleID(
            roleID.toString(),
            "5"
          );
          setPermissions(response?.data);
        }
      })();
    }
  }, [roleID]);

  const column2 = PartnersTableColumns(
    setIsDetailsModalOpen,
    setSelectedPartnerID,
    setSelectedRequest,
    setSelectedRequestID,
    setShowApprovePartnerModal,
    setViewConfirmedModal,
    navigate,
    userType,
    setShowChatModal,
    setChatData
  );

  const dateFormatter = (date: any) => {
    return `${date?.toString().substring(8, 10)}/${date
      ?.toString()
      .substring(5, 7)}/${date?.toString().substring(0, 4)}`;
  };

  const getSuitablePartnersList = (id: any) => {
    GetSuitablePartners(id)
      .then((res) => {
        setSuitableList(res.data.rows);
        setSuitableCount(String(res.data.count).padStart(2, "0"));
      })
      .catch((err) => console.log(err));
  };

  const getInterestedPartnersList = (id: any) => {
    getInterestedPartners(id)
      .then((res) => {
        setInterestedList(res.data.rows);
        setInterestedCount(String(res.data.count).padStart(2, "0"));
      })
      .catch((err) => console.log(err));
  };

  const getRecommendedPartnersList = (id: any) => {
    getRecommendedPartners(id)
      .then((res) => {
        setRecommendedList(res.data.rows);
        setRecommendedCount(String(res.data.count).padStart(2, "0"));
      })
      .catch((err) => console.log(err));
  };

  const getAcceptedPartnersList = (id: any) => {
    getAcceptedPartners(id)
      .then((res) => {
        setAcceptedList(res.data.rows);
        setAcceptedCount(String(res.data.count).padStart(2, "0"));
      })
      .catch((err) => console.log(err));
  };



  useEffect(() => {
    const GetBrandRequestProposals = async () => {
      const res = await GetInterestForBrand(params?.id);
      setNewDataCount(res.data.rows.length);
      setNewdata(res.data);
    };

    GetBrandRequestProposals();
  }, [params?.id, flag]);

  // useEffect(() => {
  //   if (
  //     permissions[0]?.sub_modules[3]?.permissions_actions[1]?.permission[0]
  //       ?.permission === true
  //   ) {
  //     const res = newdata?.rows
  //       ?.map(
  //         (dataItem: {
  //           id: any;
  //           discovery_brand: {
  //             match_completion_date: any;
  //             created_at: any;
  //             brand_id: any;
  //             id: any;
  //             country_id: number;
  //           };
  //           partner: { company_name: any };
  //           partner_id: any;
  //           partner_services: {
  //             service_id: number;
  //             recommendation_status: string;
  //             status: string;
  //           }[];
  //           status: any;
  //         }) => ({
  //           id: dataItem.id,
  //           completiondate: dataItem.discovery_brand.match_completion_date
  //             ? dateFormatter(dataItem.discovery_brand.match_completion_date)
  //             : "Not Available",
  //           brandid: dataItem.discovery_brand.brand_id,
  //           partnerName: dataItem.partner.company_name,
  //           partnerId: dataItem.partner_id,
  //           discovery_brands_id: dataItem.discovery_brand.id,
  //           focusmarket: countries.filter(
  //             (country) => country.id === dataItem.discovery_brand.country_id
  //           )[0]?.name,
  //           acceptedServices: dataItem.partner_services
  //             .filter((item) => item.status === "Accepted")
  //             ?.map(
  //               (service: {
  //                 service_id: number;
  //                 recommendation_status: string;
  //                 status: string;
  //               }) => {
  //                 if (service.service_id === 1 && service.status === "Accepted")
  //                   return {
  //                     name: "Requlatory Compliance",
  //                     status: service.recommendation_status,
  //                   };
  //                 if (service.service_id === 2 && service.status === "Accepted")
  //                   return {
  //                     name: "Importation and Clearance",
  //                     status: service.recommendation_status,
  //                   };
  //                 if (service.service_id === 3 && service.status === "Accepted")
  //                   return {
  //                     name: "Warehousing And Storage",
  //                     status: service.recommendation_status,
  //                   };
  //                 if (service.service_id === 4 && service.status === "Accepted")
  //                   return {
  //                     name: "Ecommerce Setup & Management",
  //                     status: service.recommendation_status,
  //                   };
  //                 if (service.service_id === 5 && service.status === "Accepted")
  //                   return {
  //                     name: "Retail Distribution",
  //                     status: service.recommendation_status,
  //                   };
  //                 if (service.service_id === 6 && service.status === "Accepted")
  //                   return {
  //                     name: "Order Fulfillment",
  //                     status: service.recommendation_status,
  //                   };
  //                 if (service.service_id === 7 && service.status === "Accepted")
  //                   return {
  //                     name: "Marketing",
  //                     status: service.recommendation_status,
  //                   };
  //                 return { name: "", status: "" };
  //               }
  //             ),
  //           status: dataItem.status,
  //         })
  //       )
  //       .filter(
  //         (dataItem: { status: string }) =>
  //           dataItem.status === "Completed" ||
  //           dataItem.status === "In progress" ||
  //           dataItem.status === "In Progress"
  //       );

  //     setRows3(res);
  //   }
  // }, [countries, data, flag, newdata, permissions]);

  useEffect(() => {
    const GetBrandRequestProposals = async () => {
      const res = await GetInterestForBrand(params?.id);
      setDataCount(res.data.rows.length);
      setData(res.data);
    };

    GetBrandRequestProposals();
  }, [params?.id, flag]);

  useEffect(() => {
    setDefaultTab(params?.defaultTab);
  }, [params]);

  useEffect(() => {
    const GetAllCountries = async () => {
      const res = await GetCountries();
      setCountries(res.data);
    };
    GetAllCountries();
  }, []);

  useEffect(() => {
    if (isDetailsModalOpen) {
      (async () => {
        try {
          const response = await GetPublicFiles("partner", selectedPartnerID);
          setPublicFiles(response?.data);
        } catch (error) { }
      })();
    }
  }, [isDetailsModalOpen, selectedPartnerID]);

  const onHandleTabChange = (tab: string) => {
    setActiveTab(tab);
  };

  const getLogoPlaceHolder = useCallback((name: string) => {
    return name
      ? name
        .split(" ")
        ?.map(function (str) {
          return str ? str[0].toUpperCase() : "";
        })
        .join("")
      : "";
  }, []);

  const getStatusTextStyle = useCallback((status: string) => {
    switch (status) {
      case "Open":
        return {
          background: "#D1E9FF",
          color: "#1570EF",
        };
      case "Matching Interests":
        return {
          background: "#FEF0C7",
          color: "#DC6803",
        };
      default:
        return {};
    }
  }, []);

  const tagsList = useMemo(
    () =>
      brandDetails?.brand_categories?.map((tag: any) => {
        return (
          <div key={tag?.id} className="detailsItem">
            <img src="../svgs/tag.svg" alt="tag" className="subDetailsIcon" />
            <p className="subDetails">{tag?.categories?.name}</p>
          </div>
        );
      }),
    [brandDetails]
  );

  const documentsList = useMemo(
    () =>
      brandDocumentsList?.map((doc: any, key: number) => {
        return <DocumentItem name={doc?.filename} path={doc?.path} />;
      }),
    [brandDocumentsList]
  );

  const serviceList = useMemo(
    () =>
      requestDetails?.brand_services?.map((service: any, key: number) => {
        return <p key={key}>{service?.service?.display_name}</p>;
      }),
    [requestDetails]
  );

  const marketPlaces = useMemo(() => {
    return marketPlaceDetails?.map((item: any) => {
      let logo = ""
      switch (item?.platform) {
        case "Amazon":
          logo = "../svgs/amazon-color.svg"
          break;
        case "Alibaba":
          logo = "../svgs/alibaba-color.svg"
          break;
        case "Flipkart":
          logo = "../svgs/flipkart-color.svg"
          break;
        case "Shopee":
          logo = "../svgs/shopee-color.svg"
          break;
        case "Lazada":
          logo = "../svgs/lazada-color.png"
          break;

        default:
          break;
      }

      return <Col md="auto">
        <ChipWithIcon
          icon={logo}
          text={
            item?.store_rating
              ? `${item?.store_rating}/5`
              : ""
          }
        />
      </Col>
    })
  }, [marketPlaceDetails]);

  const socialDetails = useMemo(() => {

    return socialMedialDetails?.map((item: any) => {
      const followers = item?.number_of_followers ? abbreviateNumber(item?.number_of_followers) : ""
      let logo = ""
      switch (item?.platform) {
        case "Facebook":
          logo = "../svgs/fb-color.svg"
          break;
        case "Instagram":
          logo = "../svgs/insta-color.svg"
          break;
        case "LinkedIn":
          logo = "../svgs/linkedin-color.svg"
          break;

        default:
          break;
      }

      return <Col md="auto">
        <ChipWithIcon
          icon={logo}
          text={
            item?.number_of_followers
              ? `${followers}`
              : ""
          }
        />
      </Col>
    })
  }, [socialMedialDetails])




  return (
    <Container fluid className="pge-layout">
      <Row className="row">
        <Col className="sidebar">
          <Sidebar active="discovery" />
        </Col>
        <Col className="content-section view-content-section">
          <Navbar userProfile={userProfile} />
          <Breadcrumb className="font12-medium breadcrumb-nav">
            <Breadcrumb.Item
              onClick={() => {
                navigate(-1);
              }}
            >
              DISCOVERY MANAGEMENT
              {/* <Link to="/discoverymanagement/org">DISCOVERY MANAGEMENT</Link> */}
            </Breadcrumb.Item>
            <Breadcrumb.Item
              active
            // onClick={() => {
            //   navigate(-1);
            // }}
            >
              {params?.brandName?.toLocaleUpperCase()}
            </Breadcrumb.Item>
          </Breadcrumb>
          <div className="detailsContainer">
            <div className="brandDetailsContainer">
              <div className="cardSection brandDetails">
                <Row className="brandTitleContainer">
                  <Avatar
                    sx={{ bgcolor: "#EFF8FF", color: "#0152FB" }}
                    aria-label="dp"
                  >
                    {getLogoPlaceHolder(requestDetails?.brand?.brand_name)}
                  </Avatar>
                  <Col md="auto">
                    <p className="brandTitle">
                      {requestDetails?.brand?.brand_name}
                    </p>
                    {requestDetails?.brand?.website && (
                      <a
                        className="subDetails"
                        href={`https://${requestDetails?.brand?.website}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {requestDetails?.brand?.website}
                        <img src="../svgs/link.svg" alt="link" />
                      </a>
                    )}
                  </Col>
                  <Col md="auto">
                    <p
                      className="statusText"
                      style={getStatusTextStyle(
                        requestDetails?.status
                          ? [
                            "Interest Expressed",
                            "Interest Accepted",
                            "Matching In Progress"
                          ].includes(requestDetails.status)
                            ? "Matching Interests"
                            : requestDetails.status
                          : ""
                      )}
                    >
                      {requestDetails?.status
                        ? ["Interest Expressed", "Interest Accepted", "Matching In Progress"].includes(
                          requestDetails.status
                        )
                          ? "Matching Interests"
                          : requestDetails.status
                        : ""}
                    </p>
                  </Col>
                  <Col className="marketSection">
                    <div className="detailsItem">
                      <img
                        src="../svgs/storefront.svg"
                        alt="storefront"
                        className="subDetailsIcon"
                      />
                      <p className="subDetails">
                        {
                          requestDetails?.brand?.brand_organization?.region
                            ?.name
                        }
                      </p>
                    </div>
                    {tagsList}
                  </Col>
                </Row>
                <Divider />
                <Row className="ratingSection">
                  <Col className="ratings">
                    <Row className="ratingSubSection">
                      <p className="subtitle">Marketplace</p>
                      <div className="chipsContainer">
                        {marketPlaces}
                      </div>
                    </Row>
                    <Row className="ratingSubSection">
                      <p className="subtitle">Social Media</p>
                      <div className="chipsContainer">
                        {socialDetails}
                      </div>
                    </Row>
                  </Col>
                  <Col className="documentsSection">
                    <p className="subtitle">Brand Documents</p>
                    <div className="documentsList">
                      {brandDocumentsList.length > 0 ? (
                        documentsList
                      ) : (
                        <p className="subDetails">No documents available.</p>
                      )}
                    </div>
                  </Col>
                </Row>
              </div>
              <div className="cardSection marketDetails">
                <Row>
                  <Col md="auto" className="detailItem">
                    <p className="itemLabel">Market</p>
                    <p className="itemValue">{requestDetails?.country?.name}</p>
                  </Col>
                  <Col md="auto">
                    <p className="itemLabel">Preferred Model</p>
                    <p className="itemValue">
                      {requestDetails?.engagement_model?.display_name}
                    </p>
                  </Col>
                </Row>
                <Divider />
                <Row>
                  <p className="subtitle">Required Services</p>
                  <div className="servicesContainer">{serviceList}</div>
                </Row>
              </div>
            </div>

            <div className="cardSection tabs-wraper">
              <Tabs
                activeKey="partner-list"
                id="fill-tab-example-list"
                className="tabs-global tabs-single"
                fill
              >
                <Tab
                  eventKey="partner-list"
                  title={
                    <React.Fragment>
                      <div>Partner List</div>
                    </React.Fragment>
                  }
                >
                  <div className="tabsContainer">
                    <Row className="tabBar">
                      {["administrative", "consultant"].includes(userType) ? (
                        <Col
                          className="tabItem suitable"
                          onClick={() => onHandleTabChange("suitable")}
                          style={{
                            borderBottomColor:
                              activeTab === "suitable"
                                ? "#DC6803"
                                : "transparent",
                          }}
                        >
                          <div className="tabTitle">
                            <p className="count">{suitableCount}</p>
                            <p className="type">Suitable</p>
                          </div>
                        </Col>
                      ) : (
                        <></>
                      )}

                      <Col
                        className="tabItem interested"
                        onClick={() => onHandleTabChange("interested")}
                        style={{
                          borderBottomColor:
                            activeTab === "interested"
                              ? "#F04438"
                              : "transparent",
                        }}
                      >
                        <div className="tabTitle">
                          <p className="count">{interestedCount}</p>
                          <p className="type">Interested</p>
                        </div>
                      </Col>
                      <Col
                        className="tabItem recommended"
                        onClick={() => onHandleTabChange("recommended")}
                        style={{
                          borderBottomColor:
                            activeTab === "recommended"
                              ? "#2E90FA"
                              : "transparent",
                        }}
                      >
                        <div className="tabTitle">
                          <p className="count">{recommendedCount}</p>
                          <p className="type">Recommended</p>
                        </div>
                      </Col>
                      <Col
                        className="tabItem accepted"
                        onClick={() => onHandleTabChange("accepted")}
                        style={{
                          borderBottomColor:
                            activeTab === "accepted"
                              ? "#12B76A"
                              : "transparent",
                        }}
                      >
                        <div className="tabTitle">
                          <p className="count">{acceptedCount}</p>
                          <p className="type">Accepted</p>
                        </div>
                      </Col>
                    </Row>
                    <div className="mt16px mb16px">
                      <div className="TableMUIcountainer">
                        <TableMUI
                          columns={column2}
                          rows={dataSource}
                          dataCount={partnerDataCount}
                          setListPage={setPartnerListPage}
                          listPage={partnerListPage}
                        />
                      </div>
                    </div>
                  </div>
                </Tab>
              </Tabs>
            </div>
          </div>
        </Col>

        <PartnerChat
          isModalOpen={showChatModal}
          onCancel={handleChatModal}
          chatData={chatData}
          userID={userID}
        />
        <DetailsDisplayModal
          isModalOpen={isDetailsModalOpen}
          onCancel={handleCloseDetailsModal}
          selectedRequestID={selectedRequestID}
          selectedRequest={selectedRequest}
          selectedPartnerID={selectedPartnerID}
          userType={userType}
          publicFiles={publicFiles}
        />
        <BrandApprovalPartner
          onCancel={handleCloseApprovePartner}
          setFlag={setFlag}
          flag={flag}
          isModalOpen={showApprovePartnerModal}
          title="Partner Recommendation"
          subtitle="Select services which you would like to recommend to brand:"
          buttonText="Confirm Recommendation"
          userType="Admin"
          reqDetails={selectedRequest}
        />
        <ViewRecommendedServices
          onCancel={handCloseViewConfirmedModal}
          setFlag={setFlag}
          flag={flag}
          isModalOpen={showViewConfirmedModal}
          title="Partner Recommendation"
          subtitle="Select services which you would like to recommend to brand:"
          buttonText="Confirm Recommendation"
          userType="Admin"
          reqDetails={selectedRequest}
        />
      </Row>
    </Container>
  );
}

export default RecommendPartner;
